<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="套餐号" prop="packageId">
        <el-input v-model="formInline.packageId" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="套餐名" prop="packageName">
        <el-input v-model="formInline.packageName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="套餐分类">
        <el-select v-model="formInline.packageModule" multiple placeholder="请选择">
          <el-option label="新就业形态劳动者" value="1" />
          <el-option label="企业预约" value="2" />
          <el-option label="职工及家属预约" value="3" />
          <el-option label="运动员体检预约" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="使用状态" prop="useStatus">
        <el-select v-model="formInline.useStatus" clearable placeholder="请选择">
          <el-option label="使用中" value="1" />
          <el-option label="已禁用" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <div class="table-btns">
      <el-tooltip class="box-item" effect="dark" content="删除现有套餐信息，同步相关体检机构最新套餐信息" placement="top-start">
        <el-button type="warning" :icon="InfoFilled" @click="syncShopListBtn">同步套餐信息</el-button>
      </el-tooltip>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="packageId" label="套餐号" align="center" />
      <el-table-column prop="packageName" label="套餐名" align="center" />
      <el-table-column label="项目信息" width="500" align="center">
        <template #default="scope">
          <div class="flex items-center justify-center">
            <el-button size="mini" @click="handleToggle(scope.row)"
              :icon="scope.row.expanded ? ArrowDownBold : ArrowRightBold" circle />
          </div>
          <el-table v-if="scope.row.expanded" :data="scope.row.packageItems" border style="width: 100%; margin-top: 8px"
            size="small">
            <el-table-column prop="packageItemId" label="项目编号" align="center" width="120" />
            <el-table-column prop="packageItemName" label="项目名称" align="center" />
            <el-table-column prop="extend1" label="项目描述" align="center" />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="packagePrice" label="套餐价格" align="center" />
      <el-table-column prop="packageModule" label="套餐分类" align="center" width="300" :formatter="formatType">
      </el-table-column>
      <el-table-column prop="packageType" label="套餐类型" align="center" />
      <el-table-column prop="extend1" label="备注1" align="center" />
      <el-table-column prop="extend2" label="备注2" align="center" />
      <el-table-column prop="useStatus" label="使用状态" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.useStatus === '1' ? 'success' : 'danger'">
            {{ scope.row.useStatus === '1' ? '使用中' : '已禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center" width="180">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editFn(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="delFn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
  <el-dialog v-model="dialogFormVisible" append-to-body :close-on-click-modal="false" title="修改套餐" width="500">
    <el-form :model="form" label-width="100px">
      <el-form-item label="套餐名称">
        <el-input v-model="form.packageName" placeholder="请输入套餐名称"></el-input>
      </el-form-item>
      <el-form-item label="套餐分类">
        <el-select v-model="form.packageModule" multiple placeholder="请选择套餐分类">
          <el-option label="新就业形态劳动者" value="1" />
          <el-option label="企业预约" value="2" />
          <el-option label="职工及家属预约" value="3" />
          <el-option label="运动员体检预约" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="套餐价格">
        <el-input v-model="form.packagePrice" placeholder="请输入套餐价格" type="number"><template
            #append>元</template></el-input>
      </el-form-item>
      <el-form-item label="备注1">
        <el-input v-model="form.extend1" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="备注2">
        <el-input v-model="form.extend2" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="comboInfoConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { InfoFilled, ArrowRightBold, ArrowDownBold, Check } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref([]);

const typeMap = ({
  1: '新就业形态劳动者',
  2: '企业预约',
  3: '职工及家属预约',
  4: '运动员体检预约'
})
const formatType = (row) => {
  // 1. 获取当前行的类型值（如 "1,2"）
  const typeStr = row.packageModule;
  if (!typeStr) return ''; // 空值处理

  // 2. 按逗号分割为数组（如 ["1", "2"]）
  const typeArr = typeStr.split(',');

  // 3. 遍历数组，匹配映射表中的文本，过滤无效值
  const textArr = typeArr.map(packageModule => typeMap[packageModule] || '');
  const validTexts = textArr.filter(text => text); // 去除未匹配的空文本

  // 4. 用逗号拼接有效文本并返回
  return validTexts.join(',');
};


const formInline = reactive({
  packageId: "",
  packageName: "",
  packageModule: "",
  useStatus: "",
});
const searchFormRef = ref();
const onSubmit = () => {
  _comboList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _comboList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _comboList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _comboList();
};
const _comboList = () => {
  service.post('/health/web/healthPackage/page', {
    pageSize: pageSize.value || null,
    pageNo: currentPage.value || null,
    ...formInline,
    packageModule: formInline.packageModule ? formInline.packageModule.join(",") : null
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};
const syncShopListBtn = () => {
  ElMessageBox.confirm("请确认是否同步相关体检机构最新套餐信息？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    service.get(`/health/rich/aws/syncHealthPackage?ldNo=${process.env.VUE_APP_ldNo}&packageId=${process.env.VUE_APP_packageId}`)
      .then(data => {
        console.log(data)
        if (data.data.code == 200) {
          ElMessage({
            message: "同步成功，已加载所有套餐",
            type: "success",
          });
          _comboList();
        }
      })
      .catch(err => {
        ElMessage({
          message: err.message,
          type: "error",
        });
      })
  })
}

const delFn = (row) => {
  ElMessageBox.confirm(`请确认是否删除 ${row.packageName} 套餐？`, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    service.delete('/health/web/healthPackage/delete/' + row.id)
      .then(data => {
        console.log(data)
        if (data.data.code == 200) {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          _comboList();
        }
      })
      .catch(err => {
        ElMessage({
          message: err.message,
          type: "error",
        });
      })
  })
}


let dialogFormVisible = ref(false)
const form = reactive({
  packageName: "",
  packageModule: "",
  packagePrice: "",
  extend1: "",
  extend2: "",
});
const editFn = (row) => {
  form.packageName = row.packageName
  form.packageId = row.packageId
  form.packageModule = row.packageModule ? row.packageModule.split(",") : null
  form.packagePrice = row.packagePrice
  form.extend1 = row.extend1
  form.extend2 = row.extend2
  dialogFormVisible.value = true
}
const comboInfoConfirm = () => {
  service.post('/health/web/healthPackage/update', {
    ...form,
    packageModule: form.packageModule.join(",")
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        ElMessage({
          message: "修改成功",
          type: "success",
        });
        dialogFormVisible.value = false
        _comboList();
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
}
onMounted(() => {
  _comboList();
});

const handleToggle = (row) => {
  row.expanded = !row.expanded;
};
</script>
<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}
</style>
